/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

interface Props {
  path: string;
  authToken?: string;
  style?: object;
  hideToolbar?: boolean;
}

const PdfViewer: React.FC<Props> = (props) => {
  if (!props.path) { return null; }
  const encodedAuth = props.authToken ? `&Authorization=${encodeURIComponent(`Basic ${props.authToken}`)}` : '';
  const url = encodeURIComponent(props.path);
  const basePath = props.hideToolbar ? '/pdfjs/web/viewer-no-toolbar.html' : '/pdfjs/web/viewer.html';
  const src = `${basePath}?file=${url}${encodedAuth}`;

  /*
  this is using pdfjs viewer to render the pdf.
  The Authorization query param is custom change to the pdfjs/web/viewer.js file

  modified to open links in external window/tabs
  viewer.js ~line 9769
  "externalLinkTarget": 2
  */
  const style = {
    width: '100%',
    height: '100%',
    margin: '0 auto',
    ...props.style,
  };

  return (
    <iframe src={src} style={style} />
  );
};

export default PdfViewer;
